import {
  isIOS,
  isAndroid,
  deviceType,
  mobileModel,
  browserName,
  osName,
} from "react-device-detect";

const getPlatform = () => {
  if (isIOS) return "c1";
  if (isAndroid) return "m1";
  return "w1";
};

const isWebView = () => {
  const ua = navigator.userAgent || navigator.vendor || "";

  // react-device-detect: some in-app browsers report as 'WebView' or 'WebKit'
  const lowerBrowser = browserName ? browserName.toLowerCase() : "";
  const isLibDetect =
      lowerBrowser.includes("webview") || lowerBrowser.includes("webkit");

  // Standard Android/iOS User Agent patterns
  const isUADetect =
      /Android.*wv/i.test(ua) || // Android WebView
      (/iPhone|iPad|iPod/i.test(ua) &&
          !/Safari/i.test(ua) &&
          /AppleWebKit/i.test(ua)); // iOS WebView omits 'Safari'

  // Windows WebView2 exposes window.chrome.webview
  const win = window as Window & { chrome?: { webview?: unknown } };
  const isWebView2 = !!(win.chrome?.webview);

  return isLibDetect || isUADetect || isWebView2;
};

export const getUserDeviceData = () => {
  return {
    browserName,
    $os: osName,
    $os_version: osName,
    osName: osName,
    platform: getPlatform(),
    device_type: deviceType,
    deviceType: deviceType,
    mp_device_model: mobileModel !== "none" ?  mobileModel : deviceType,
    device: mobileModel !== "none" ?  mobileModel : deviceType,
    $model: mobileModel !== "none" ?  mobileModel : deviceType,
    $brand: deviceType,
    $manufacturer: deviceType,
    is_web_view: isWebView(),
  };
};
